export const UPDATE_EVENT = 'dashboard/UPDATE_EVENT'
export const UPDATE_REGISTRATION = 'dashboard/UPDATE_REGISTRATION'
export const UPDATE_TEAM = 'dashboard/UPDATE_TEAM'
export const UPDATE_PROJECTS = 'dashboard/UPDATE_PROJECTS'
export const UPDATE_ANNOTATOR = 'dashboard/UPDATE_ANNOTATOR'
export const UPDATE_PROJECT_SCORES = 'dashboard/UPDATE_PROJECT_SCORES'

export const EDIT_REGISTRATION = 'dashboard/EDIT_REGISTRATION'
export const EDIT_TEAM = 'dashboard/EDIT_TEAM'
export const EDIT_PROFILES = 'dashboard/EDIT_PROFILES'
export const EDIT_ANNOTATOR = 'dashboard/EDIT_ANNOTATOR'

export const CLEAR_TEAM = 'dashboard/CLEAR_TEAM'
